export default __webpack_public_path__ + "static/media/avatar_16.ebfb94a3.svg";